module.exports = __webpack_public_path__ + "img/skier.48c84214.svg";